import * as React from 'react';

import {ChevronDownIcon, ChevronRightIcon} from '../icon';
import {StackLegacy} from '../layout/stack/stack-legacy';

import styles from './expanding-folder.module.css';

type Props = {
    icon?: React.ComponentType<any>;
    title: string;
    isExpanded?: boolean;
    children: React.ReactNode;
};

export function ExpandingFolder(props: Props) {
    const [expanded, setExpanded] = React.useState<boolean>(false);

    React.useEffect(() => {
        setExpanded(Boolean(props.isExpanded));
    }, [props.isExpanded]);

    const Icon = props.icon;

    return (
        <div className={styles.container}>
            <div onClick={() => setExpanded(!expanded)} className={styles.header}>
                <StackLegacy isHorizontal={true} spacing={6} alignCenter={true}>
                    {Icon ? <Icon size={16} alignCenter={true} /> : undefined}
                    <div className={styles.title}>{props.title}</div>
                </StackLegacy>
                {expanded ? <ChevronDownIcon size={12} /> : <ChevronRightIcon size={12} />}
            </div>
            <div className={expanded ? styles['content--expanded'] : styles.content}>
                {props.children}
            </div>
        </div>
    );
}
